export const getNextLesson = (chapters, chapterId, lessonId) => {
  const currentChapterIndex = chapters.findIndex(
    (chapter) => chapter.id === chapterId,
  )
  const chapterCount = chapters.length
  const currentLessonIndex = chapters[currentChapterIndex].lessons.findIndex(
    (lesson) => lesson.id === lessonId,
  )
  const lessonCount = chapters[currentChapterIndex].lessons.length

  let targetLessonIndex, targetChapterIndex

  if (currentLessonIndex + 1 >= lessonCount) {
    targetLessonIndex = 0
    if (currentChapterIndex + 1 >= chapterCount) {
      targetChapterIndex = 0
    } else {
      targetChapterIndex = currentChapterIndex + 1
    }
  } else {
    targetChapterIndex = currentChapterIndex
    targetLessonIndex = currentLessonIndex + 1
  }
  return {
    chapter: chapters[targetChapterIndex].id,
    lesson: chapters[targetChapterIndex].lessons[targetLessonIndex].id,
  }
}

export const getPrevLesson = (chapters, chapterId, lessonId) => {
  const currentChapterIndex = chapters.findIndex(
    (chapter) => chapter.id === chapterId,
  )
  const currentLessonIndex = chapters[currentChapterIndex].lessons.findIndex(
    (lesson) => lesson.id === lessonId,
  )

  let targetLessonIndex, targetChapterIndex

  if (currentLessonIndex === 0) {
    if (currentChapterIndex === 0) {
      targetLessonIndex = 0
      targetChapterIndex = 0
    } else {
      targetChapterIndex = currentChapterIndex - 1
      targetLessonIndex = chapters[targetChapterIndex].lessons.length - 1
    }
  } else {
    targetChapterIndex = currentChapterIndex
    targetLessonIndex = currentLessonIndex - 1
  }

  return {
    chapter: chapters[targetChapterIndex].id,
    lesson: chapters[targetChapterIndex].lessons[targetLessonIndex].id,
  }
}
